export default {
  isAuthenticated: (state) => state.isAuthenticated,
  token: (state) => state.token,
  currentUser: (state) => state.currentUser,
  errors: (state) => state.errors,
  loading: (state) => state.loading,
};
